import { PartnerDetailPage } from "@/features/rso/pages/PartnerDetail";

const MatchDetail = () => {
  return <PartnerDetailPage />;
};

export default MatchDetail;
